import styled from "@emotion/styled";

export const RegularText = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  margin: 0;
`;

export const SmallText = styled.span`
  letter-spacing: 0.5px;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
`;

export const Heading2 = styled.h2`
  margin: 0;
  font-size: 24px;
  font-weight: 400;
  line-height: 125%;
`;

export const Heading3 = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
`;

export const Heading4 = styled.h4`
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
`;

export const Heading5 = styled.h5`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 2px;
  text-transform: uppercase;
`;
